import { render, staticRenderFns } from "./details_list.vue?vue&type=template&id=4a615ae6&scoped=true"
import script from "./details_list.vue?vue&type=script&lang=js"
export * from "./details_list.vue?vue&type=script&lang=js"
import style0 from "./details_list.vue?vue&type=style&index=0&id=4a615ae6&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a615ae6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a615ae6')) {
      api.createRecord('4a615ae6', component.options)
    } else {
      api.reload('4a615ae6', component.options)
    }
    module.hot.accept("./details_list.vue?vue&type=template&id=4a615ae6&scoped=true", function () {
      api.rerender('4a615ae6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dms/views/channelPoolVague/channelPoolMain/form/details_list.vue"
export default component.exports